export enum DiasSemanaEnum {
    SEGUNDA_FEIRA = 'SEGUNDA-FEIRA',
    TERCA_FEIRA = 'TERCA-FEIRA',
    QUARTA_FEIRA = 'QUARTA-FEIRA',
    QUINTA_FEIRA = 'QUINTA-FEIRA',
    SEXTA_FEIRA = 'SEXTA-FEIRA',
    SABADO = 'SABADO',
    DOMINGO = 'DOMINGO',
}
